import ActionsBar from './ActionsBar';
import './ActionsBar.scss';

export default ActionsBar;